module.exports = __webpack_public_path__ + "static/media/vedang.c5c041d1.jpg";